import { cn } from 'noddi-ui-common';

type StatTone = 'brand' | 'warn' | 'default';

const TONE_STYLES: Record<StatTone, { card: string; value: string }> = {
  brand: { card: 'border-card-selected-background bg-white', value: 'text-primary' },
  warn: { card: 'bg-warning50 border-warning50', value: 'text-warningDark' },
  default: { card: 'bg-card border-border', value: 'text-foreground' }
};

type StatProps = {
  label: string;
  value: string | number;
  sub?: string;
  tone?: StatTone;
};

const Stat = ({ label, value, sub, tone = 'default' }: StatProps) => {
  const style = TONE_STYLES[tone];
  return (
    <div className={cn('flex flex-col gap-1 rounded-xl border p-4', style.card)}>
      <div className='text-[11px] font-semibold tracking-wider text-muted-foreground uppercase'>{label}</div>
      <div className={cn('text-2xl font-semibold tabular-nums', style.value)}>{value}</div>
      {sub && <div className='text-xs text-muted-foreground'>{sub}</div>}
    </div>
  );
};

type StatStripProps = {
  stats: StatProps[];
};

export const StatStrip = ({ stats }: StatStripProps) => (
  <div className='grid grid-cols-2 gap-3 md:grid-cols-4'>
    {stats.map((stat) => (
      <Stat key={stat.label} {...stat} />
    ))}
  </div>
);
